export interface EmployeeCompensation {
  employeeTemplate: EmployeeTemplateItem;
  employeeTemplates: EmployeeTemplateItem[];
  // [items, total]
  employeeProductivityTemplates: [EmployeeProductivityTemplateItem[], number];
  employeeCompensations: EmployeeCompensationItem[];
}

interface EmployeeCompensationItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy?: unknown;
  ownerList?: unknown;
  employeeId: number;
  workLevelId: number;
  compensationId?: string;
  orgId: number;
  compensation: Template;
}

export interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

interface EmployeeTemplateItem {
  id: string;
  status: number;
  employeeId: number;
  template: Template;
}

interface EmployeeProductivityTemplateItem {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: number;
  createdBy: CreatedBy;
  updatedBy: CreatedBy;
  orgId: number;
  employeeId: number;
  employeeCode: string;
  productivityTemplateId: string;
  productivityTemplate: Template;
}

interface Template {
  id: string;
  status: number;
  code: string;
  name: string;
  nativeName: string;
}

export enum ECompensationHistoryType {
  EARNING = "EARNING",
  ALLOWANCE = "ALLOWANCE",
  DEDUCTION = "DEDUCTION",
  BENEFIT_IN_KIND = "BENEFIT_IN_KIND",
}

export interface CompensationHistory {
  id: string;
  orgId: number;
  employeeId: number;
  employeeCode: string;
  compensationType: ECompensationHistoryType;
  referenceId: string;
  referenceCode: string;
  referenceName: string;
  referenceNativeName: string;
  oldData: Record<string, unknown>;
  newData: Record<string, unknown>;
  createdBy: CreatedBy | null;
  createdAt: string;
  itemCreatedAt?: string | null;
}

export interface CompensationHistoryListRequest {
  employeeId?: number;
  compensationType?: ECompensationHistoryType;
  referenceId?: string;
  page?: number;
  limit?: number;
}

export interface CompensationHistoryListResponse extends RestAPIMetaResponse {
  items: Array<CompensationHistory>;
}
